<article class="privacyArticle">
    <form [formGroup]="formPrivacy">
        <div class="formPrivacyContainer">
            <div class="boxContainer" *ngFor="let item of linksContainer">
                <mat-checkbox color="primary" [formControlName]="item.control" ngDefaultControl></mat-checkbox>
                <span [innerHTML]="item.description"></span>
            </div>
        </div>
    </form>
</article>